import React, { useState, useEffect } from "react";

const TOUCH_DEVICE =
  luvit && luvit.ua
    ? luvit.ua.indexOf("applewebkit", 0) > 0 &&
      (luvit.ua.indexOf("iphone", 0) > 0 || luvit.ua.indexOf("ipad", 0) > 0)
    : false;

function useTouchDeviceCheck() {
  const [touchDevice, setTouchDevice] = useState(TOUCH_DEVICE);

  useEffect(() => {
    const handleResize = () => setTouchDevice(TOUCH_DEVICE);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return touchDevice;
}

export default useTouchDeviceCheck;
